import React from 'react';
import styled from '@emotion/styled';
import { Helmet } from 'react-helmet';
import ArticleWrap from '../../components/organisms/articleWrap';
import ArticleBody from '../../components/organisms/articleBody';
import ColumnDetailAside from '../../components/organisms/columnDetail/columnDetailAside';
import ArticleHeader from '../../components/molecules/articleHeader';
import ArticleSection from '../../components/molecules/articleSection';
import ArticleImage from '../../components/atoms/articleImage';
import TextBlock from '../../components/molecules/textBlock';
import Text from '../../components/atoms/text';
import Caption from '../../components/atoms/caption';
import ColumnRecommendItems from '../../components/organisms/columnDetail/columnRecommendItems';
import ColumnRecommendItemsSection from '../../components/organisms/columnDetail/columnRecommendItemsSection';
import Br from '../../components/atoms/br';
import { getProductItem } from '../../assets/js/lib/getProducts';

const Container = styled.div`
`;

const ColumnDetail = () => {
  return(
    <Container>
      <Helmet
          title="痛くないし、定期検診に行く時間もない！むし歯を放置するとどうなるの？ | お口の健康コラム | モンダミン 公式サイト | アース製薬"
          meta={[
              { name: 'description', content: '子どもも大人も、むし歯になるのは同じなのに、大人にはむし歯が進行しても気付きにくい理由があるようです。むし歯にならないために大切なポイントや、簡単に取り入れられるケア方法などをご紹介します。' },
              { name: 'keywords', content: 'マウスウォッシュ,洗口液,液体ハミガキ,液体歯磨き,モンダミン,もんだみん,mondahmin,大人むし歯,むし歯,オーラルケア,アース製薬' }
          ]}
        >
        <body data-block-header="true" />
      </Helmet>
      <ArticleWrap>
        <ArticleBody>
          <ArticleHeader sub={<>痛くないし、<Br onlySp />定期検診に行く時間もない！</>} title={<>むし歯を放置するとどうなるの？</>} filename={'column/08/img-01.jpg'}>
            子どもも大人も、むし歯になるのは同じなのに、大人にはむし歯が進行しても気付きにくい理由があるようです。
          </ArticleHeader>
          <ArticleSection heading={<>気付かぬうちに進行してしまう、大人むし歯とは？</>}>
            <TextBlock>
              <Text>むし歯とは、口内にいる細菌が糖質を分解して作り出した酸によって、歯が溶けてしまった状態のことです。このメカニズムは大人も子どもも同じですが、大人のむし歯には以下のような特徴があります。</Text>
              <Text><b>＜大人むし歯の特徴＞</b><br />・加齢や歯周病によって歯ぐきが下がり、露出してしまった歯質が弱い部分に細菌が付着し、むし歯になってしまう<br />・以前に治療した詰め物の隙間に細菌と歯垢がたまり、内側の見えないところで再発する<br />・神経を取った歯は痛みを感じにくく、いつの間にかむし歯が再発して進行してしまう</Text>
              <Text>これらの理由から、大人はむし歯に気付きにくく、また、仕事や家事で忙しいため、歯科医院へ行くことの優先順位が下がり、むし歯を放置してしまうことが多いようです。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>むし歯を放置したらどうなるの？</>}>
            <TextBlock>
              <ArticleImage filename={'column/08/img-02.jpg'}></ArticleImage>
              <Text>大人のむし歯は「特に痛みがない」「歯科医院に行く時間がない」などといった理由で放置されてしまう傾向にあります。しかし、症状が悪化するほどに歯科医院に通院する回数も増え、時間的にも金銭的にも負担が多くなってしまいます。<br />また、食事の際にむし歯を避けて咀嚼することで十分にかまずに飲み込んで胃腸に負担をかけてしまったり、かみ合わせが悪くなり、顔のゆがみを招いてしまうなど、歯以外にも影響が出てしまうことがあります。さらには、かみ合わせの悪さが筋肉バランスの崩れ、肩こり、頭痛などの不調につながってしまう可能性もあるため、早い段階でケアすることが大切です。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>むし歯にならないために大切なこと</>}>
            <TextBlock>
              <Text>むし歯菌<sup>*1</sup>は糖質を分解して「グルカン」という物質を作り出します。「グルカン」はネバネバしているので、さらにたくさんの細菌がくっついて繁殖し、歯垢（プラーク）<sup>*2</sup>というかたまりになります。また、歯垢にいるむし歯菌が糖質を分解し、作り出した酸によって歯が溶けてむし歯になってしまいます。</Text>
              <Caption>＊1むし歯の原因となる細菌にはさまざまな種類がありますが、ここではまとめて「むし歯菌」と呼びます。</Caption>
              <Caption>＊2プラーク1mgのなかには、およそ300種類1億個ものの細菌が存在しているといわれています。</Caption>
              <Text>したがって、むし歯にならないためには「むし歯菌のエサとなる糖質を減らすこと」「歯垢やむし歯菌を減らすこと」が重要で、食後の歯磨きが効果的と言われています。とはいえ日中は忙しく、ていねいに歯磨きをする時間がないという方もいるのではないでしょうか。そこで、時間のない時でも簡単にできる、おすすめのホームケアをご紹介します。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>大人は忙しい！洗口液を使ったホームケアを習慣にしよう！</>}>
            <TextBlock>
              <Text>むし歯を防ぐポイントは、「むし歯菌のエサとなる糖質を減らすこと」「歯垢やむし歯菌を減らすこと」の２つ。「わかってはいるけれど、ランチライムの残り時間に歯磨きするのは難しい……」そんな時にぜひ取り入れたいのが、洗口液を使ったホームケアです。<br />洗口液は食べカスやネバつきを洗い流してむし歯菌のエサとなる糖質を減らし、口内全体を清潔にします。使い方は、口に含んで20〜30秒すすぐだけ。その後は水ですすぐ必要はありません。また、洗口液は歯ブラシでは磨きにくい小さな隙間にも届くので、歯磨き後の磨き残し対策としておすすめです。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>就寝前は、1日で最も大切なオーラルケアタイム</>}>
            <TextBlock>
              <ArticleImage filename={'column/08/img-04.jpg'}></ArticleImage>
              <Text>歯垢は食後約4〜8時間でできると言われています。また、睡眠中は唾液が少なくなるため自浄作用が低下し、むし歯菌が活発になります。したがって、就寝前のオーラルケアをしっかり行うことが重要です。</Text>
              <Text>ていねいに歯磨きしても、「歯と歯の間」や「歯と歯ぐきとの境目」「詰め物・被せものの境目」などは汚れが落としにくいもの。就寝前は通常の歯磨きに加えて歯間ブラシやデンタルフロス、洗口液を活用して磨き残し対策をしましょう。<br />洗口液を使う時は、歯の隙間などお口のすみずみに届くように20〜30秒を目安にしっかりすすぎましょう。また、洗口液には殺菌効果が長時間持続するタイプや、歯垢の付着を予防する効果がある洗口液もあります。お悩みに合わせて洗口液を使い分けてみるのもおすすめです。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>忙しい大人こそ、時短でできるむし歯対策を！</>}>
            <TextBlock>
              <Text>大人むし歯は、いつの間にか進行しているやっかいなもの。むし歯を防ぐためには、毎日コツコツとケアを続けていくことが大切です。そのためには、忙しい毎日でも無理なく続けられるように、食事の後には洗口液、寝る前のケアは念入りにとメリハリをつけるのがポイント。あわせて、定期的に歯科検診を受け、むし歯にならないように気をつけましょう。</Text>
            </TextBlock>
          </ArticleSection>
        </ArticleBody>
      </ArticleWrap>
      <ColumnRecommendItemsSection>
        <ColumnRecommendItems title={<>むし歯など、<Br onlySp></Br>様々なお口のトラブル予防に</>} column={[3,2]} items={getProductItem(['モンダミン プレミアムケア', 'モンダミン プレミアムケア センシティブ', 'モンダミン プレミアムケア センシティブ プレミアムシトラスミント', 'モンダミン プレミアムケア ストロングミント', '自動で出てくるモンダミン プレミアムケアセット'])}></ColumnRecommendItems>
        <ColumnRecommendItems title={"よごれの除去と付着予防に"} items={getProductItem(['モンダミン ペパーミント', 'モンダミン センシティブ', 'モンダミン ストロングミント',])}></ColumnRecommendItems>
      </ColumnRecommendItemsSection>
      <ColumnDetailAside></ColumnDetailAside>
    </Container>
  );
};
export default ColumnDetail;
